import React from "react";
import { FaExclamationTriangle, FaHome, FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

function NotFoundScreen() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-primary100 flex flex-col justify-center items-center p-4">
      <div className="w-full max-w-lg bg-white rounded-2xl shadow-2xl overflow-hidden">
        {/* Header Section */}
        <div className="bg-primary100 px-8 py-12 text-center">
          <div className="relative">
            <div className="w-24 h-24 bg-white rounded-full flex justify-center items-center mx-auto mb-4 shadow-lg">
              <FaExclamationTriangle className="text-primary100 text-3xl animate-pulse" />
            </div>
            {/* Animated rings */}
            <div className="absolute inset-0 flex justify-center items-center">
              <div className="w-32 h-32 border-2 border-white/30 rounded-full animate-ping"></div>
            </div>
          </div>
          <h1 className="text-6xl font-bold text-white mb-2">404</h1>
          <p className="text-blue-100 text-sm">
            Page Not Found
          </p>
        </div>

        {/* Content Section */}
        <div className="px-8 py-8">
          {/* Error Message */}
          <div className="text-center mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">
              <span className="text-red-500">Oops!</span> We can't find that page
            </h2>
            <p className="text-gray-600 mb-6">
              The page you're looking for doesn't exist or has been moved.
            </p>
          </div>

          {/* Possible Causes */}
          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <h4 className="font-semibold text-gray-800 mb-3">This might have happened because:</h4>
            <ul className="text-sm text-gray-600 space-y-2">
              <li className="flex items-start space-x-2">
                <span className="text-primary100 mt-1">•</span>
                <span>The URL was typed incorrectly</span>
              </li>
              <li className="flex items-start space-x-2">
                <span className="text-primary100 mt-1">•</span>
                <span>The page has been moved or deleted</span>
              </li>
              <li className="flex items-start space-x-2">
                <span className="text-primary100 mt-1">•</span>
                <span>You don't have permission to access this page</span>
              </li>
              <li className="flex items-start space-x-2">
                <span className="text-primary100 mt-1">•</span>
                <span>The link you followed is broken</span>
              </li>
            </ul>
          </div>

          {/* Action Buttons */}
          <div className="space-y-3">
            <button
              onClick={() => navigate("/homedashboard")}
              className="w-full bg-primary100 text-white py-4 rounded-lg font-semibold text-lg hover:opacity-90 transform hover:scale-[1.02] transition-all duration-200 shadow-lg hover:shadow-xl flex items-center justify-center space-x-2"
            >
              <FaHome />
              <span>Go to Dashboard</span>
            </button>

            <button
              onClick={() => navigate(-1)}
              className="w-full bg-gray-100 text-gray-700 py-4 rounded-lg font-semibold text-lg hover:bg-gray-200 transform hover:scale-[1.02] transition-all duration-200 shadow-md hover:shadow-lg flex items-center justify-center space-x-2"
            >
              <FaArrowLeft />
              <span>Go Back</span>
            </button>
          </div>

          {/* Help Text */}
          <div className="mt-6 text-center">
            <p className="text-xs text-gray-500">
              Need help? <span className="text-primary100 hover:underline cursor-pointer">Contact support</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotFoundScreen;